import moment from 'moment';

export const dateToString = (date?: Date) => moment(date).format('DD.MM.YYYY.');
